import { observable, action } from 'mobx';

class TableOfContentStoreModule {
  @observable blockStates = new Map();
  @observable activeBlock = null;

  @action.bound
  setPosition(blockdata) {
    // update the viewport position for this block
    this.blockStates.set(blockdata.offsetKey, blockdata);
    // convert map to array and filter out the vertically highest block from all blocks, that is 'inside' or 'above'
    const entries = Array.from(this.blockStates.values());
    // if we dont have any block that is visible, the active block should be 'null'
    if (
      entries.filter(
        f => f.currentPosition === 'inside' || f.currentPosition === 'above',
      ).length === 0
    ) {
      this.activeBlock = null;
    } else {
      // seems like are are visible blocks, so lets filter for them
      this.activeBlock = entries
        .filter(
          f => f.currentPosition === 'inside' || f.currentPosition === 'above',
        )
        // sorting gives us to top-most element + we only need the [0] (first) element
        .sort((a, b) => b.element.offsetTop - a.element.offsetTop)[0];
    }
  }
}

const TableOfContentStore = new TableOfContentStoreModule();
export default TableOfContentStore;
